import React from "react";
import { AudioPlayer, AudioPlayerGroup } from "../../../../components";
import rain from "../../../../assets/sound/rain.mp3";
import sound from "../../../../assets/sound/sound.mp3";

const AudioPlayerList = () => {
  return (
    <div className="w-full h-full flex-1 flex justify-center items-center flex-col gap-4">
      <AudioPlayer file={rain} download={{ isHideDownload: true }} />
      <AudioPlayer file={sound} download={{ isDownloadable: false }} />
    </div>
  );
};

export default AudioPlayerList;
